import { below } from '@voll-intelligence/ui-kit/breakpoints';
import { useMediaQuery } from '@voll-intelligence/ui-kit/hooks/use-media-query';

/** Abaixo de `sm` na VIEWPORT — a régua do celular de verdade. */
export const PHONE_VIEWPORT_QUERY = below('sm');

/**
 * A tela é um celular? (#3875, padronização de 30/09.)
 *
 * Diferente do `useOfferLayout`, que mede o CONTAINER e decide o desenho do
 * card, esta pergunta é sobre a VIEWPORT: uma tela cheia por cima da conversa
 * só faz sentido quando a conversa É a tela. Uma coluna estreita num desktop
 * (a lista do explorer ao lado dos cortes numa story, um painel lateral) desenha
 * o card empilhado, mas a escolha de tarifa ali segue no lugar de sempre, sem
 * cobrir a janela inteira. `false` quando o host não sabe responder
 * (`matchMedia` ausente): o desenho que não depende do tamanho.
 */
export function usePhoneViewport(): boolean {
  return useMediaQuery(PHONE_VIEWPORT_QUERY);
}
